// extracted by mini-css-extract-plugin
module.exports = {"MediaSaying":"MediaSaying_MediaSaying__0Kwb1"};